import { dayjs } from '@weft/utils';
import type { Optional } from '@weft/utils';
import type { Dayjs } from '@weft/utils';

export function getDefaultDates(): [Dayjs, Dayjs] {
  const from = dayjs().subtract(1, 'day').startOf('day');
  const to = dayjs().endOf('day');

  return [from, to];
}

export function unixToDayjs(dateStr: Optional<string>) {
  return dateStr ? dayjs.unix(+dateStr) : undefined;
}

export function convertDateForUrlParams(date: Dayjs) {
  return date.unix().toString();
}
